import Button from '@/components/input/Button';
import { ArrowBack } from '@mui/icons-material';
import React, { PropsWithChildren } from 'react';
import { Link, useNavigate } from 'react-router';

interface Props {
  href?: string;
}

const BackButton: React.FC<PropsWithChildren<Props>> = ({ href, children }) => {
  const navigate = useNavigate();

  if (!href)
    return (
      <Button variant="ghost" Icon={ArrowBack} onClick={() => navigate(-1)}>
        {children}
      </Button>
    );

  return (
    <Link to={href} style={{ display: 'flex', alignItems: 'center' }}>
      <Button variant="ghost" Icon={ArrowBack}>
        {children}
      </Button>
    </Link>
  );
};

export default BackButton;
